import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import { DatePicker } from 'antd';
import moment from 'moment';
import OpenFileLink from './OpenFileLink';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';

const CollapsePanel = Collapse.Panel;
const { TextArea } = Input;

//employersData are hardcoded by client's requirements for only allowing two employers 
const getEmployersDataAvailable = employersData => {
  if (!employersData || !employersData.employer1 || !employersData.employer2) {
    return false;
  }

  const employer1 = employersData.employer1
  const employer2 = employersData.employer2
  if (employer1.currentEmployer === false && employer2.currentEmployer === false)
    return false
  
  if (employer1.currentEmployer === true) {
    for (let key of Object.keys(employer1)) {
      //employer's phone number is not mandatory
      if (key === "phone") {
        continue
      }
      let val = employer1[key]
      if (val === undefined || val === null || val.toString().trim() === '') {
        return false
      }
      if (typeof val === 'object') {
        for (let addressVal of Object.values(val)) {
          if (addressVal === undefined || addressVal === null || addressVal.toString().trim() === '') {
            return false
          }
        }
      }
    }
    return true
  } else {
    for (const key of Object.keys(employer2)) {
      //employer's phone number is not mandatory
      if (key === "phone") {
        continue
      }
      const val = employer2[key]
      if (val === undefined || val === null || val.toString().trim() === '') {
        return false
      }
      if (typeof val === 'object') {
        for (let addressVal of Object.values(val)) {
          if (addressVal === undefined || addressVal === null || addressVal.toString().trim() === '') {
            return false
          }
        }
      }
    }
   
    return true
  }  
}



const PayrollDeductionsCollapse = ({ token, loanId, payrollDeductionsSentDate, loanNotes, employersData, onSaveNotes, t }) => {

  const initialSentDate = payrollDeductionsSentDate ? moment(payrollDeductionsSentDate) : moment()
  const employersDataAvailable = useMemo(()=>getEmployersDataAvailable(employersData), [employersData])
  const [sentDate, setSentDate] = useState(initialSentDate.toISOString())
  const [notes, setNotes] = useState('')

  useEffect(() => {
    setNotes(loanNotes)
  },[loanNotes])

  const handleSentDateChange = (date) => {
    setSentDate(moment(date, "DD.MM.YYYY").toISOString())
  }

  const handleNotesChange = (e) => {
    e.preventDefault()
    setNotes(e.target.value)
  }

  return (   
    <Collapse>
    

      <CollapsePanel header={t('Dohoda o zrážkach zo mzdy')}>
        {!employersDataAvailable && 
      <div style={{color: "red"}}>Chýbajúce údaje o zamestnávateľovi</div>
        }
        {employersDataAvailable && 
          <div>
            <span>
              Zrážky zaslané dňa
            </span>
            <DatePicker
            allowClear={false}
            showToday={true}
            onChange={(date, dateString) => handleSentDateChange(dateString)}
              format={'DD.MM.YYYY'}
            style={Object.assign({ margin: 15 })}              
            value={moment(sentDate)}
              />
          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/loan/payrollDeductionsRequest?token=${token}&loanId=${loanId}&sentDate=${moment(sentDate).format("YYYY-MM-DD")}`}
            style={{ marginLeft: 15 }}
            classNames="primary"
          >
            Vygeneruj PDF
            </OpenFileLink>
            <div>
                    <TextArea
                  size="default"
                  placeholder={t('Poznámky')}
                autosize={{ minRows: 4, maxRows: 10 }}
                value={notes}
                onChange={handleNotesChange}
              />
            <Button size="default" className="btn-inline" onClick={()=>onSaveNotes(notes)} >{t('Uložiť poznámky')}</Button>
            </div>
            </div>
        }
         
      </CollapsePanel>
         
         
    </Collapse>)
};

PayrollDeductionsCollapse.propTypes = {
  loanId: PropTypes.string.isRequired,
  payrollDeductionsSentDate: PropTypes.string,
  loanNotes: PropTypes.string,
  t: PropTypes.func.isRequired,
  employersData: PropTypes.object.isRequired
};

export default translate()(PayrollDeductionsCollapse);



// WEBPACK FOOTER //
// ./src/common/components/data-display/PayrollDeductionsCollapse.js